// w5.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W5 = () => {
  return <WW config={pageConfigs.w5} />;
};

export default W5;
